import { t } from "@/i18n-js/instance";
import { SortableList } from "@circle-react-uikit/SortableList";
import { Typography } from "@circle-react-uikit/Typography";
import { I18N_ROOT } from "../";
import { useMobileHomeSegmentsContext } from "../MobileHomeSegmentsContext";
import { MobileHomeSegmentItem } from "./MobileHomeSegmentItem";

export const MobileHomeSegments = () => {
  const { orderedMobileHomeSegments, setOrderedMobileHomeSegments } =
    useMobileHomeSegmentsContext();
  return (
    <div className="mb-3">
      <div className="mb-1">
        <Typography.LabelMd weight="semibold">
          {t([I18N_ROOT, "mobile_home_segments_order", "title"])}
        </Typography.LabelMd>
      </div>
      <Typography.BodyMd size="text-sm">
        {t([I18N_ROOT, "mobile_home_segments_order", "subtitle"])}
      </Typography.BodyMd>
      <div className="bg-primary border-primary mt-6 flex border-b py-3 pl-12 pr-6">
        <Typography.LabelXs weight="semibold">
          {t([I18N_ROOT, "mobile_home_segments_order", "menu_title"])}
        </Typography.LabelXs>
      </div>
      <SortableList
        items={orderedMobileHomeSegments}
        onSort={setOrderedMobileHomeSegments}
        lockedVerticalAxis
        distance={10}
      >
        <SortableList.List gap={0} className="divide-y">
          {orderedMobileHomeSegments.map(segment => (
            <SortableList.Item
              key={segment.id}
              item={segment}
              className="border-primary h-14"
            >
              <MobileHomeSegmentItem />
            </SortableList.Item>
          ))}
        </SortableList.List>
        <SortableList.DragOverlay shouldRestrictToParent>
          <div className="border-primary border-y shadow-md">
            <MobileHomeSegmentItem />
          </div>
        </SortableList.DragOverlay>
      </SortableList>
    </div>
  );
};
